export default __webpack_public_path__ + "static/media/analytices1.9fa95eb0.png";